import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { InputSelectTextComponent } from './input-select-text.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
  ],
  declarations: [InputSelectTextComponent],
  exports: [InputSelectTextComponent],
})
export class InputSelectTextModule {
}
